/**
 * User: Rob Richard
 * Date: 1/16/14
 * Time: 5:03 PM
 */

"use strict";

var Backbone = require('dibs-backbone');
var SoaModel = require('bunsen/models/SoaModel');
var Permissions = module.exports = SoaModel.extend();
var endpoints = require('dibs-endpoints');
var PermissionList = require('bunsen/collections/identity/PermissionList');
var _ = require('underscore');

_.extend(Permissions.prototype, {
    url: endpoints.permission,
    relations : [{
        key : 'permissionList',
        collectionType: PermissionList,
        type: Backbone.Many
    }],
    parse: function (data) {
        var permissions;
        var mapping;
        if (data.permissionList) {
            permissions = data;
            mapping = data.rolePermissionMappings;
        } else if (data.result && data.result.permissions && data.result.permissions.permissionList) {
            permissions = data.result.permissions;
            mapping = data.result.permissions.rolePermissionMappings;
        } else {
            return data;
        }

        //parse the roles - permissions mapping
        if (permissions && mapping) {
            _.each(permissions.permissionList, function (permission) {
                permission.roles = [];
                _.each(_.where(mapping, {value: permission.id}), function (role) {
                    permission.roles.push({
                        id: role.name
                    });
                });
            });
        }

        return permissions;
    },
    /**
     * Check permissions for a given user. Provide the user's permission set as the second argument.
     * @param required - The required permission to complete this action.
     * @returns {*}
     */
    checkPermissions: function (required) {
        // Return true if nothing is passed in for required
        if (!required || _.isEmpty(required)) {
            return true;
        }

        // If required is a string, check if it's in the available array
        if (typeof required === 'string') {
            return !!this.get('permissionList').checkPermissions({name: required});
        }
        // If required is an array, check if at least one of them is in available
        return _.some(required, function (perm) {
            return !!this.get('permissionList').checkPermissions({name: perm});
        }, this);
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/Permissions.js
// module id = 2643
// module chunks = 63